import module from 'usuario/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

const duracion = [{id: 2, descripcion: '2 min'}, {id: 15, descripcion: '15 min'}, {id: 30, descripcion: '30 min'},
  {id: 60, descripcion: '60 min'}, {id: 120, descripcion: '120 min'}]

let roles = [{rol: 'ADMIN'}, {rol: 'USER'}]

export class UsuarioEditarComponent {
  promise = undefined
  onClose = undefined
  duracion = duracion
  roles = roles
  data = {}
  usuarioId = null

  constructor (Usuario, UsuariosCatalogosDepartamentosService, UsuariosCatalogosPuestosService, UsuariosCatalogosMasterService, $q, $state) {
    this.Usuario = Usuario
    this.UsuariosCatalogosDepartamentosService = UsuariosCatalogosDepartamentosService
    this.UsuariosCatalogosPuestosService = UsuariosCatalogosPuestosService
    this.UsuariosCatalogosMasterService = UsuariosCatalogosMasterService
    this.$q = $q
    this.$state = $state
  }

  $onInit () {
    this.promise = this.$q.all([
      this.UsuariosCatalogosMasterService.get()
        .then((response) => (this.isMaster = response.data.master)),
      this.UsuariosCatalogosDepartamentosService.get()
        .then((response) => (this.departamentos = orderBy(response.data, ['descripcion']))),
      this.UsuariosCatalogosPuestosService.get()
        .then((response) => (this.puestos = orderBy(response.data, ['descripcion']))),
    ])
  }

  cerrar () {
    this.onClose()
  }

  guardar () {

    if (this.modificando) return

    this.modificando = true
    this.error = null

    this.Usuario.put(this.data, this.usuarioId)
      .then(({data}) => {
        this.data = data
        this.form.$setPristine()
      })
      .catch(({data}) => (this.error = data))
      .finally(() => (this.modificando = false))
  }
}

module.component('usuarioEditar', {
  controller: UsuarioEditarComponent,
  template,
  bindings: {
    usuarioId: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/editar/component.js